import type { WorkflowOptions } from '../../types';
import { addAddressWorkflow } from './addAddressWorkflow';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { editAddressWorkflow } from './editAddressWorkflow';

export const workflows: WorkflowOptions[] = [
  addAddressWorkflow,
  editAddressWorkflow,
  ...Object.values(generateAssetStatusWorkflow('address', { deleteAction: true })),
];

export default workflows;
